import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Avatar, Typography, Box, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const SlidersTableRow = ({
    slider,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(slider.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, slider.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* العنوان مع الصورة */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {slider.image && (
                        <Avatar
                            src={slider.image}
                            alt={slider.title}
                            sx={{ width: 60, height: 40 }}
                            variant="rounded"
                        />
                    )}
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {isArabic
                                ? (slider?.title?.ar || slider?.title?.en || (typeof slider?.title === 'string' ? slider.title : '-'))
                                : (slider?.title?.en || slider?.title?.ar || (typeof slider?.title === 'string' ? slider.title : '-'))
                            }
                        </Typography>
                    </Box>
                </Box>
            </TableCell>

            {/* العنوان الفرعي */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {isArabic
                    ? (slider?.sub_title?.ar || slider?.sub_title?.en || (typeof slider?.sub_title === 'string' ? slider.sub_title : '-'))
                    : (slider?.sub_title?.en || slider?.sub_title?.ar || (typeof slider?.sub_title === 'string' ? slider.sub_title : '-'))
                }
            </TableCell>
            {/* الحالة */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Chip
                    label={slider?.is_active ? (isArabic ? 'مفعّل' : 'Active') : (isArabic ? 'معطّل' : 'Inactive')}
                    color={slider?.is_active ? 'success' : 'default'}
                    size="small"
                    variant="outlined"
                />
            </TableCell>
            {/* نص الزر */}
            {/* <TableCell align={isArabic ? 'right' : 'left'}>
                {isArabic
                    ? (slider?.btn_text?.ar || slider?.btn_text?.en || (typeof slider?.btn_text === 'string' ? slider.btn_text : '-'))
                    : (slider?.btn_text?.en || slider?.btn_text?.ar || (typeof slider?.btn_text === 'string' ? slider.btn_text : '-'))
                }
            </TableCell> */}

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {slider?.created_at ? dayjs(slider.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, slider)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default SlidersTableRow;